import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import axios from "axios";

function AddContactFJ({ show, close, fetchJournalTab, numberToAdd }) {
  var phoneNumber = numberToAdd;
  const compte = localStorage.getItem("compte");
  const posteCol = localStorage.getItem("poste");
  const token = localStorage.getItem("AccessToken");
  const BackendURL = window.BackendURLCmk;

  const [nom, setNom] = useState("");

  const [mobile, setMobile] = useState(phoneNumber);

  const [tel, setTel] = useState("");

  const [tel2, setTel2] = useState("");

  const [tel3, setTel3] = useState("");

  const [entreprise, setEntreprise] = useState("");

  const [mail, setMail] = useState("");

  const handleOk = () => {
    const config1 = {
      headers: {
        Authorization: token,
      },
    };
    const phoneNumber = document.getElementById("phoneNumber_id").value;

    const data = new URLSearchParams();
    data.append("compte", compte);
    data.append("poste", posteCol);
    data.append("action", "create");
    data.append("id", "");
    data.append("nom_prenom", nom);
    data.append("email", mail);
    data.append("adresse", entreprise);
    data.append("tel_portable", phoneNumber);
    data.append("tel_fix", tel);
    data.append("tel_3", tel2);
    data.append("tel_4", tel3);
    data.append("tel_5", "");
    data.append("commentaire", "");

    const url = `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/CRUDContactCarnetAdresseIPBXV3API`;

    axios
      .post(url, data, {
        ...config1,
        headers: {
          ...config1.headers,
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .then((res) => {
        close();
        fetchJournalTab();
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          // var link = "/";
          // window.location.replace(link);
        } else {
          // console.log("AXIOS ERROR: ", err);
        }
      });
  };

  return (
    <div>
      <Modal
        title="Ajouter contact"
        visible={show}
        onOk={handleOk}
        onCancel={close}
      >
        <div className="flex justify-between m-3">
          <div style={{ display: "grid" }}>
            <label>Nom</label>
            <input
              type="text"
              value={nom}
              onChange={(e) => setNom(e.target.value)}
              style={{ border: "1px solid #afafaf" }}
            />
          </div>
          <div style={{ display: "grid" }}>
            <label>Mobile</label>
            <input
              id="phoneNumber_id"
              type="text"
              value={numberToAdd}
              //   onChange={(e) => setMobile(e.target.value)}
              style={{ border: "1px solid #afafaf" }}
            />
          </div>
        </div>
        <div className="flex justify-between m-3">
          <div style={{ display: "grid" }}>
            <label>Entreprise</label>
            <input
              type="text"
              value={entreprise}
              onChange={(e) => setEntreprise(e.target.value)}
              style={{ border: "1px solid #afafaf" }}
            />
          </div>
          <div style={{ display: "grid" }}>
            <label>Téléphone</label>
            <input
              type="text"
              value={tel}
              onChange={(e) => setTel(e.target.value)}
              style={{ border: "1px solid #afafaf" }}
            />
          </div>
        </div>

        <div className="flex justify-between m-3">
          <div style={{ display: "grid" }}>
            <label>Téléphone 2</label>
            <input
              type="text"
              value={tel2}
              onChange={(e) => setTel2(e.target.value)}
              style={{ border: "1px solid #afafaf" }}
            />
          </div>
          <div style={{ display: "grid" }}>
            <label>Téléphone 3</label>
            <input
              type="text"
              value={tel3}
              onChange={(e) => setTel3(e.target.value)}
              style={{ border: "1px solid #afafaf" }}
            />
          </div>
        </div>
        <div className="flex justify-between	m-3">
          <div style={{ display: "grid" }}>
            <label>E-mail</label>
            <input
              type="text"
              value={mail}
              onChange={(e) => setMail(e.target.value)}
              style={{ border: "1px solid #afafaf" }}
            />
          </div>{" "}
        </div>
      </Modal>
    </div>
  );
}

export default AddContactFJ;
